import React from 'react';
import styles from 'routes/adminMobile/components/AdminMobileOrderDetailComp.module.css';
import FlexChild from 'layouts/flex/FlexChild';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import AdminMobileEmptyMsg from './common/AdminMobileEmptyMsg';
import { mainPadd2, pageEH2FontSize, pageEH3FontSize, registerGap2 } from '../constraints/AdminConst';
import AdminMobileContentBox from './common/AdminMobileContentBox';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';
import P from 'components/P';

const AdminMobileOrderDetailComp = ({orderData}) => {
    // orderData 존재하지 않는 경우에 대한 예외 처리
    if (!orderData) {
        return (
            <VerticalFlex>
                <FlexChild padding={mainPadd2}>
                    <AdminMobileEmptyMsg />
                </FlexChild>
            </VerticalFlex>
        );
    }
    

    return (
        <AdminMobileContentBox flexStart>
            <VerticalFlex gap={"0.5rem"}>
                <FlexChild >
                    <div className={styles.borderBottom}>
                        <HorizontalFlex>
                            <FlexChild justifyContent="center" >
                                <P size={pageEH2FontSize}>상세 발주 내역</P>
                            </FlexChild>
                        </HorizontalFlex>
                    </div>
                </FlexChild>
                <FlexChild >
                    <div className={styles.borderBottom}>
                        <VerticalFlex gap={registerGap2}>
                            <FlexChild>
                                <HorizontalFlex gap={registerGap2}>
                                    <FlexChild width={"initial"}>
                                        {orderData.mainProductImage ? (
                                            <img className={styles.productImg} src={orderData.mainProductImage} alt="대표 이미지" width={"20%"} />
                                        ) : (
                                            <div>이미지 없음</div>
                                        )}
                                    </FlexChild>
                                    <FlexChild>
                                        <VerticalFlex gap={registerGap2}>
                                            <FlexChild>
                                                <HorizontalFlex>
                                                    <FlexChild>
                                                        <HorizontalFlex gap={registerGap2}>
                                                            <FlexChild width="auto">
                                                                <P size={pageEH3FontSize}>
                                                                    {orderData.orderDate ? orderData.orderDate : "날짜 없음"}
                                                                </P>
                                                            </FlexChild>
                                                            <FlexChild>
                                                                <P size={pageEH3FontSize}>
                                                                    {orderData.storeName ? orderData.storeName : "점포명 없음"}
                                                                </P>
                                                            </FlexChild>
                                                        </HorizontalFlex>
                                                    </FlexChild>
                                                    <FlexChild width="auto">
                                                        {orderData.orderStatus ? (
                                                            <>
                                                                {orderData.orderStatus === "accept" && (
                                                                    <div className={styles.statusBox}>
                                                                        <P size={pageEH3FontSize}>접수</P>
                                                                    </div>
                                                                )}
                                                                {orderData.orderStatus === "deliver" && (
                                                                    <div className={styles.statusBox}>
                                                                        <P size={pageEH3FontSize}>배송중</P>
                                                                    </div>
                                                                )}
                                                                {orderData.orderStatus === "cancel" && (
                                                                    <div className={styles.statusCancelBox}>
                                                                        <P size={pageEH3FontSize}>취소</P>
                                                                    </div>
                                                                )}
                                                            </>
                                                        ) : (
                                                            <div>상태 없음</div>
                                                        )}
                                                    </FlexChild>
                                                </HorizontalFlex>
                                            </FlexChild>
                                            <FlexChild alignItems="flex-start">
                                                <P size={pageEH2FontSize}>
                                                    {orderData.mainProduct && orderData.otherProductsString ? `${orderData.mainProduct} ${orderData.otherProductsString}` : '상품명 없음'}
                                                </P>
                                            </FlexChild>
                                            <FlexChild alignItems="flex-start">
                                                <P size={pageEH2FontSize} weight={700}>
                                                    {orderData.totalOrderAmount ? orderData.totalOrderAmount.toLocaleString() : 0} 원
                                                </P>
                                            </FlexChild>
                                        </VerticalFlex>
                                    </FlexChild>
                                </HorizontalFlex>
                            </FlexChild>
                        </VerticalFlex>
                    </div>
                </FlexChild>
                <FlexChild >
                    <VerticalFlex >
                        <FlexChild>
                            <div className={styles.paddTopBott}>
                                <HorizontalFlex>
                                    <FlexChild justifyContent="center">
                                        <span className={styles.fontSize}>총&nbsp;</span>
                                        <span className={styles.color}>
                                            {orderData.totalOrderQuantity ? orderData.totalOrderQuantity.toLocaleString() : 0} 개&nbsp;
                                        </span>
                                        <span className={styles.fontSize}>상품,&nbsp;</span>
                                        <span className={styles.bold}>
                                            {orderData.totalOrderAmount ? orderData.totalOrderAmount.toLocaleString() : 0} 원
                                        </span>
                                    </FlexChild>
                                </HorizontalFlex>
                            </div>
                        </FlexChild>
                        
                        {orderData.productOrderDetails ? (
                            <FlexChild>
                                {orderData.productOrderDetails.map((productOrder, index) => (
                                    <div key={index} className={styles.paddTopBott2}>
                                        <HorizontalFlex gap={registerGap2} >
                                            <FlexChild width="auto">
                                                <img className={styles.productImg} src={productOrder.productImage} alt="Product" />
                                            </FlexChild>
                                            <FlexChild>
                                                <VerticalFlex gap={registerGap2}>
                                                    <FlexChild alignItems="flex-start">
                                                        <P size={pageEH2FontSize}>
                                                            {productOrder.productName ? productOrder.productName : "제품 없음"},&nbsp;
                                                            {productOrder.orderQuantity ? productOrder.orderQuantity.toLocaleString() : 0} 개
                                                        </P>
                                                    </FlexChild>
                                                    <FlexChild alignItems="flex-start">
                                                        <P size={pageEH2FontSize}>
                                                            {productOrder.orderAmount ? productOrder.orderAmount.toLocaleString() : 0} 원
                                                        </P>
                                                    </FlexChild>
                                                </VerticalFlex>
                                            </FlexChild>
                                        </HorizontalFlex>
                                    </div>
                                ))}
                            </FlexChild>
                        ) : (
                            <div>데이터가 없습니다.</div>
                        )}
                        
                    </VerticalFlex>
                </FlexChild>
            </VerticalFlex>
        </AdminMobileContentBox>
    );
};

export default AdminMobileOrderDetailComp;